const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class LoyaltyTiersCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    if (window.BAO.MediaBreakpoints.isSm) {
      this.handleTierClick = this.handleTierClick.bind(this)

      this.els.slide.elements.forEach((item) => {
        this.listeners.add(item, 'click', this.handleTierClick)
      })
    }
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
          origin: 'center',
        },
        slideChanged: this.onSlideChanged,
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }

  onSlideChanged (instance) {
    const current = instance?.track?.details?.rel

    const slides = instance?.slides
    slides.forEach((slide, i) => {
      slide.classList.toggle('blk-Tier-active', i === current)

      if (i === current) {
        this.externalEls.reward.elements.forEach((rewardEl) => {
          if (rewardEl.dataset.tier === slide.dataset.tier) {
            rewardEl.setAttribute('aria-hidden', 'false')
          } else {
            rewardEl.setAttribute('aria-hidden', 'true')
          }
        })
      }
    })

    this.setupRewardsCarousel()
  }

  handleTierClick (event) {
    const currentTier = event.target.closest(this.els.slide.selector)

    this.els.slide.elements.forEach((slideEl) => {
      slideEl.classList.remove('blk-Tier-active')
    })
    currentTier.classList.add('blk-Tier-active')
  }

  setupRewardsCarousel () {
    if (!this.externalEls.reward?.exists) return

    return new KeenSlider(
      this.externalEls.rewards.element,
      {
        selector: `${this.externalEls.reward.selector}:not([aria-hidden='true'])`,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.7,
              spacing: 1,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.3,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.externalEls?.next?.element,
          previous: this.externalEls?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('loyalty-tiers-carousel')) {
  customElements.define('loyalty-tiers-carousel', LoyaltyTiersCarousel)
}
